module.exports = __webpack_public_path__ + "static/media/undo.d7b3607e.svg";